/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Manager_Languages_CountInputs */

const en_knp_manager_languages_count = /** @type {(inputs: Knp_Manager_Languages_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} languages`)
};

const fr_knp_manager_languages_count = /** @type {(inputs: Knp_Manager_Languages_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} langues`)
};

const de_knp_manager_languages_count = /** @type {(inputs: Knp_Manager_Languages_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Sprachen`)
};

const it_knp_manager_languages_count = /** @type {(inputs: Knp_Manager_Languages_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lingue`)
};

const ru_knp_manager_languages_count = /** @type {(inputs: Knp_Manager_Languages_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} языки`)
};

const es_knp_manager_languages_count = /** @type {(inputs: Knp_Manager_Languages_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} idiomas`)
};

const zh_cn2_knp_manager_languages_count = /** @type {(inputs: Knp_Manager_Languages_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 语言`)
};

const ja_knp_manager_languages_count = /** @type {(inputs: Knp_Manager_Languages_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 言語`)
};

const hi_knp_manager_languages_count = /** @type {(inputs: Knp_Manager_Languages_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} भाषाएँ`)
};

const pt_pt2_knp_manager_languages_count = /** @type {(inputs: Knp_Manager_Languages_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} idiomas`)
};

/**
* | output |
* | --- |
* | "{count} languages" |
*
* @param {Knp_Manager_Languages_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_languages_count = /** @type {((inputs: Knp_Manager_Languages_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Languages_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_languages_count(inputs)
	if (locale === "de") return de_knp_manager_languages_count(inputs)
	if (locale === "it") return it_knp_manager_languages_count(inputs)
	if (locale === "ru") return ru_knp_manager_languages_count(inputs)
	if (locale === "es") return es_knp_manager_languages_count(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_languages_count(inputs)
	if (locale === "ja") return ja_knp_manager_languages_count(inputs)
	if (locale === "hi") return hi_knp_manager_languages_count(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_languages_count(inputs)
	return en_knp_manager_languages_count(inputs)
});